import gql from 'graphql-tag'

export const EVENTS_QUERY = gql`
query EventsLatestSignificantUpdatesPinned($countryFilter: Boolean) {
  eventsLatestSignificantUpdatesPinned(countryFilter: $countryFilter) {
    results {
      id
      event{
        category {
          name
          code
        }
        country {
          id
          iso2
          nameShort
        }
        title
        isActive
        level
        significantUpdateAt
        staticPageUrl
        timeEnd
        timeStart
        countUpdates
        gmUniqueEventId
      }
      travelersNow
      travelersPotentiallyAffected
    }
  }
}
`

export const PIN_EVENT_MUTATION = gql`
mutation PinEvent($input: PinEventInputType!) {
  pinEvent(input: $input) {
    ok
  }
}
`

export const UNPIN_EVENT_MUTATION = gql`
mutation UnpinEvent($input: UnpinEventInputType!) {
  unpinEvent(input: $input) {
    ok
  }
}
`